import { ListLayoutLauncherProps } from "../../page/ListLayoutLauncher";
import { RowCountLabel } from "../table/headingPanel/searchFilter/RowCountLabel";
import { Table } from "../table/Table";
import { Textbox } from "./Textbox";

export class LookupModelLayoutCountLabel extends RowCountLabel {
    constructor(table: Table, textbox: Textbox) {
        super(table, {
            marginLeft: 12,
            fontSize: undefined
        });

        if (textbox.listLayout != null) {
            this.listLayout = textbox.listLayout;
            this.linkToListLayout = true;
            this._element.tabIndex = -1;
        }
    }

    get listLayoutLauncherProps(): ListLayoutLauncherProps {
        return {
            listLayout: this.listLayout,
            keyValues: this.getKeyValues
        };
    }

    private getKeyValues = (): string[] => {
        const keyField = this.table.dataSource?.getMetadataFromCache()?.keyFields[0];
        if (keyField == null)
            return [];
        return this.table.rows?.map(row => row.data?.get(keyField))?.filter(Boolean);
    }
}
